import { Component, CSSProperties } from "react";
import { Button, CircularProgress, Snackbar } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";

import HubRiseActionCreator from "../../controller/action/HubRiseActionCreator";
import HubRiseStore from "../../controller/store/HubRiseStore";

import hubRiseLogo from "../../assets/images/hubRise_logo.png";
import LoadingComponent from "../utils/LoadingComponent";
import Service from "../../controller/model/service/Service";
import PopinaStore from "../../controller/store/PopinaStore";
import { ALERT_SEVERITY } from "../../controller/constant/ActionConstant";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";

interface StateInterface {
  service: Service;
  restaurant: PopinaRestaurant;
  isReady: boolean;
  showAlert: boolean;
  message: string | undefined;
  alertSeverity: "success" | "info" | "warning" | "error";
  sendingCatalog: boolean
}

const _updateState = () => {
  return {
    service: HubRiseStore.service,
    restaurant: PopinaStore.restaurant,
  };
};

class HubRiseContainer extends Component {
  public props: any;
  public state: StateInterface;

  constructor(props: any) {
    super(props);
    this.state = {
      service: HubRiseStore.service,
      restaurant: PopinaStore.restaurant!,
      isReady: false,
      showAlert: false,
      message: undefined,
      alertSeverity: "info",
      sendingCatalog: false
    };
  }

  componentDidMount() {
    HubRiseStore.addChangeListener(this._handleStateChange);
    PopinaStore.addChangeListener(this._handleStateChange);

    const urlParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlParams.get("code");

    if (authorizationCode) {
      HubRiseActionCreator.connectHubRiseServiceUser(authorizationCode)
        .then(() => {
          this.props.history.push("/home/hubrise");
        })
        .catch((err) => {
          console.warn(err);
          this.setState({
            showAlert: true,
            alertSeverity: ALERT_SEVERITY.error,
            message: "Erreur de connexion",
          });
        })
        .finally(() => {
          this.setState({ isReady: true });
        });
    } else {
      HubRiseActionCreator.loadHubRiseServiceUser()
        .catch((err: any) => {
          console.warn(err);
          this.setState({
            showAlert: true,
            alertSeverity: ALERT_SEVERITY.error,
            message: "Error lors de la récupération des infos HubRise",
          });
        })
        .finally(() => {
          this.setState({ isReady: true });
        });
    }
  }

  componentWillUnmount() {
    HubRiseStore.removeChangeListener(this._handleStateChange);
  }

  _handleStateChange = () => {
    this.setState(_updateState());
  };

  _handleTextfieldChange = (e: any) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  _handleTapConnectButton = () => {
    const redirectUri = window.location.href.split("?")[0];
    const accountName = this.state?.restaurant?.name || "Popina Restaurant";
    const locationName = this.state?.restaurant?.ticket_city || "";
    const countryCode = (this.state?.restaurant?.locale || "_FR").split("_")[1];
    HubRiseActionCreator.navigateToAuthorizationPage(redirectUri, accountName, locationName, countryCode);
  };

  _handleTapDisconnectButton = () => {
    HubRiseActionCreator.disconnectHubRiseService()
      .catch((err: any) => {
      console.warn(err);
      this.setState({
        showAlert: true,
        alertSeverity: ALERT_SEVERITY.error,
        message: "Erreur lors de la déconnexion, veuillez réessayer",
      });
    });
  };

  _handleTapUploadCatalogButton = () => {
    this.setState({ sendingCatalog: true });
    HubRiseActionCreator.upLoadCatalog(
      this.state.service,
      this.state.restaurant
    )
      .then(() =>
        this.setState({
          showAlert: true,
          alertSeverity: ALERT_SEVERITY.success,
          message: "Le catalogue est chargé avec succès",
          sendingCatalog: false
        })
      )
      .catch((err) => {
        console.log('UPLOAD CATALOG ERROR', err);
        this.setState({
          showAlert: true,
          alertSeverity: ALERT_SEVERITY.error,
          message: "Erreur lors du chargement du catalogue",
          sendingCatalog: false
        })
      }
      );
  };

  _handleCloseSnackBar = () => {
    this.setState({ showAlert: false });
  };

  render() {
    return (
      <div style={rootStyle}>
        <Snackbar
          open={this.state.showAlert}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <MuiAlert
            severity={this.state.alertSeverity}
            onClose={this._handleCloseSnackBar}
          >
            {this.state.message}
          </MuiAlert>
        </Snackbar>
        {this.state.isReady ? (
          <div>
            {!this.state.service.actived ? (
              <div
                style={{
                  height: "100%",
                  textAlign: "center",
                  margin: "20px",
                  backgroundColor: "#f2f2f2",
                  border: "1px solid #e1e1e1",
                  borderRadius: "6px",
                }}
              >
                <div
                  className="hubrise_image"
                  style={{ marginTop: "30px", width: "100%" }}
                >
                  <img src={hubRiseLogo} style={imgStyle()} alt="hubrise" />
                    <div style={{ marginTop: "10px", padding: "20px", display:"flex",  justifyContent: "center",
                    alignItems: "center" }}>
                    <a className="hubrise_link" target="_blank" rel="noreferrer" href="https://manager.hubrise.com/"> Aller à hubrise </a>
                      <Button
                        variant="contained"
                        onClick={this._handleTapConnectButton}
                        style={{
                          color: "white",
                        }}
                        color="secondary"
                      >
                        Connexion
                      </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div style={rootStyle}>
                <div
                  style={{
                    padding: "30px 0px",
                    margin: "20px",
                    backgroundColor: "#f2f2f2",
                    border: "1px solid #e1e1e1",
                    borderRadius: "6px",
                  }}
                >
                  <img src={hubRiseLogo} style={imgStyle()} alt="hubrise" />
                  <div style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display:"flex"
                  }}>
                    <h3>Vous êtes actuellement connecté à HubRise</h3>
                  </div>
                  <div>
                  <a className="hubrise_link" target="_blank" rel="noreferrer" href="https://manager.hubrise.com/"> Aller à hubrise </a>
                    <Button
                      color="secondary"
                      variant="outlined"
                      onClick={this._handleTapDisconnectButton}
                    >
                      Déconnexion
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <div style={{display:'flex', flexDirection:'column',margin: "20px",}}>
            <div
              style={{
                marginBottom:"15px",
                backgroundColor: "#fcfcfc",
                border: "1px solid #e1e1e1",
                borderRadius: "6px",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            > 
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "0 20px",
                  boxSizing: "border-box",
                  alignItems: "flex-start",
                }}
              >
                <div>
                <p
                  style={{
                    textAlign:"left",
                    fontWeight:500,
                    color: this.state.service.actived ? "inherit" : "#bbbbbb",
                  }}
                >
                  Point de vente:{" "}
                  <strong style={{ color: "#84c967" }}>
                    {`${this.state.service.locationName} ${this.state.service.accountName} - ${this.state.service.locationId}`}
                  </strong>
                </p>
                <p
                  style={{
                    textAlign:"left",
                    fontWeight:500,
                    color: this.state.service.actived ? "inherit" : "#bbbbbb",
                  }}
                >
                  Catalogue:{" "}
                  <strong style={{ color: "#84c967" }}>
                    {`${this.state.service.catalogName} - ${this.state.service.catalogId}`}
                  </strong>
                </p>
                <p
                  style={{
                    textAlign:"left",
                    fontWeight:500,
                    color: this.state.service.actived ? "inherit" : "#bbbbbb",
                  }}
                >
                  Liste de clients:{" "}
                  <strong style={{ color: "#84c967" }}>
                    {`${this.state.service.customerListName} - ${this.state.service.customerListId}`}
                  </strong>
                </p>
                </div>
              </div>
            </div>
            <Button
                disabled={
                  !this.state.service.actived || this.state.sendingCatalog
                }
                color="secondary"
                variant="outlined"
                onClick={this._handleTapUploadCatalogButton}
                startIcon={
                  this.state.sendingCatalog && (
                    <CircularProgress
                      style={{ width: "20px", height: "20px" }}
                      color="inherit"
                    />
                  )
                }
                style={{
                  alignSelf: "start"
                }}
              >
                Envoyer la carte vers HubRise
            </Button>
          </div>
          </div>
        ) : (
          <div style={rootStyle}>
            <LoadingComponent isOpen={this.state.isReady} />
          </div>
        )}
      </div>
    );
  }
}

const rootStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  textAlign: "center",
};

const imgStyle = (): CSSProperties => {
  return {
    width: "300px",
    margin: "auto",
  };
};

export default HubRiseContainer;
